const Play = ({ height, width }: { height?: number; width?: number }) => {
  const _height = height ? height : 20;
  const _width = width ? width : 20;

  return (
    <svg
      width={_width}
      height={_height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2998 9.86221L9.14688 6.84294C8.99447 6.73244 8.79215 6.7158 8.6251 6.80167C8.45672 6.88687 8.35156 7.05993 8.35156 7.24697V13.2835C8.35156 13.4726 8.45672 13.6449 8.6251 13.7301C8.69631 13.7661 8.77418 13.7841 8.85271 13.7841C8.9552 13.7841 9.05903 13.7514 9.14688 13.6869L13.2998 10.6703C13.4309 10.5738 13.5075 10.4247 13.5075 10.2662C13.5081 10.1052 13.4296 9.95673 13.2998 9.86221Z"
        fill="#139982"
      />
      <path
        d="M10.0003 0.251953C4.47639 0.251953 0 4.72894 0 10.2536C0 15.7763 4.47639 20.252 10.0003 20.252C15.5229 20.252 20 15.7756 20 10.2536C20.0007 4.72894 15.5229 0.251953 10.0003 0.251953ZM10.0003 18.5832C5.40015 18.5832 1.67049 14.8551 1.67049 10.2536C1.67049 5.65416 5.40015 1.92134 10.0003 1.92134C14.5998 1.92134 18.3288 5.65349 18.3288 10.2536C18.3295 14.8551 14.5998 18.5832 10.0003 18.5832Z"
        fill="#139982"
      />
    </svg>
  );
};

export default Play;
